import { Injectable } from '@angular/core';
import { Observable, ReplaySubject } from 'rxjs';
import { Profile } from '../../models/user.model';
import { HttpClient, HttpParams } from '@angular/common/http';
import { ProfileUriService } from './profile-uri.service';
import { PreInitials } from '../../models/pre-initial.models';
import { UserProfile } from 'src/app/core/models/initials.model';


@Injectable({ providedIn: 'root' })

export class ProfileGatewayService {

    constructor(private profileUriService: ProfileUriService, private http: HttpClient) { }

    getUserProfile(): Observable<UserProfile> {
        const url = this.profileUriService.getUserProfileUri();
        return this.http.get<UserProfile>(url);
    }
    
    getCompanyProfile(): Observable<Profile> {
        const url = this.profileUriService.getCompanyProfileUri();
        return this.http.get<Profile>(url);
    }

    userUpdateProfile(data, id?): Observable<Profile> {
        let url = this.profileUriService.getUserUpdateProfileUri();
        if (id) url = this.profileUriService.getUserProfileByIdUri(id);
        return this.http.put<Profile>(url, data);
    }

    public getPreInitials(): Observable<PreInitials> {
        let params = new HttpParams();
        params = params.append('pre', true.toString());

        const url = this.profileUriService.shellInitialUri();
        return this.http.get<any>(url, { params });
    }

}